/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiPanel } from '@elastic/eui'

import { useGetCCMClusters } from '@modules/ccm-user-lib/hooks'

import CCMClusterTitleContent from './CCMClusterTileContent'

import type { FC } from 'react'

const CCMClustersTile: FC = () => {
  const { data: connectedClusters, isLoading, isSuccess } = useGetCCMClusters()

  return (
    <EuiPanel hasShadow={true} grow={false}>
      <CCMClusterTitleContent
        connectedClusters={connectedClusters}
        isLoading={isLoading}
        isSuccess={isSuccess}
      />
    </EuiPanel>
  )
}

export default CCMClustersTile
